import Table from 'react-bootstrap/Table';

const TipoDetalle = ({row})=> {

    return (
        <div>
            <Table striped hover responsive size="sm" style={{fontSize: '1em'}}>
                <tbody>
                    <tr>
                        <td width="50%">idProyecto</td>
                        <td width="50%">{row.IDPROYECTO}</td>
                    </tr>
                    <tr>
                        <td>Nombre proyecto</td>
                        <td>
                            {row.NOMBREPROYECTO}
                        </td>
                    </tr>
                    <tr>
                        <td>Fecha inicio</td>
                        <td>{row.INICIO}</td>
                    </tr>
                    <tr>
                        <td>Fecha fin</td>
                        <td>{row.FIN}</td>
                    </tr>
                    <tr>
                        <td>Presupuesto</td>
                        <td>{row.PRESUPUESTO}</td>
                    </tr>
                    <tr>
                        <td>Saldo</td>
                        <td>{row.SALDO}</td>
                    </tr>
                    <tr>
                        <td>Estatus</td>
                        <td>{row.ESTATUS}</td>
                    </tr>
                    <tr>
                        <td>Usuario Responsable</td>
                        <td>{row.NOMBREUSUARIORESPONSABLE}</td>
                    </tr>
                    <tr>
                        <td>Horas por semana</td>
                        <td>{row.HORASSEMANA}</td>
                    </tr>
                    <tr>
                        <td>Horas por dia</td>
                        <td>{row.HORASDIA}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
}

export default TipoDetalle;